// import icon from '../../../icon'
// import { map } from 'lodash'
import React, { useContext } from 'react';
import './index.scss';
import Switch from '../../UI/Switch';
import { JSDCContext } from '../../../JSDC/Context';
import { Marker } from 'leaflet';
import Button from '../../UI/Button';
import { DuiContext } from '../../Context';

export interface IToolSettingDialogContentProps {}

const ToolSettingDialogContent: React.FC<
  IToolSettingDialogContentProps
> = ({}: IToolSettingDialogContentProps) => {
  const { trailQuery, toolSetting, setToolSetting, clusterControll, heatMapControll } =
    useContext(JSDCContext);
  const dui = useContext(DuiContext);

  const handleClusterChange = (clusterEnable: boolean) => {
    setToolSetting((prev) => ({ ...prev, cluster: clusterEnable }));
    clusterEnable ? clusterControll.setShow() : clusterControll.setHide();
    if (!clusterEnable && toolSetting.hotspot) {
      trailQuery.trailsLayer.forEachLayerAsGeoJSON<Marker>((layer) => {
        layer.setOpacity(0);
      });
    }
  };
  const handleHotspotChange = (hotSpotEnable: boolean) => {
    setToolSetting((prev) => ({ ...prev, hotspot: hotSpotEnable }));
    hotSpotEnable ? heatMapControll.setShow() : heatMapControll.setHide();
    if (hotSpotEnable && !toolSetting.cluster) {
      trailQuery.trailsLayer.forEachLayerAsGeoJSON<Marker>((layer) => {
        layer.setOpacity(0);
      });
    }
    if (!hotSpotEnable) {
      trailQuery.trailsLayer.forEachLayerAsGeoJSON<Marker>((layer) => {
        layer.setOpacity(1);
      });
    }
  };

  const shouldGoToSearchTreePanel = () => {
    const length = trailQuery.trailsLayer.instance?.getLayers().length;
    return !length;
  };

  const handleGoSearchTreePanel = () => {
    dui.menuSwitch('河溪搜尋');
  };
  return (
    <div className="dui-ToolSettingDialogContent">
      <div className="dui-ToolSettingDialogContent-ToolSet">
        <div className="dui-ToolSettingDialogContent-ToolSet-Tool">
          <label>叢集 Cluster</label>
          <Switch
            checked={toolSetting.cluster}
            onChange={() => handleClusterChange(!toolSetting.cluster)}
          />
        </div>
        <div className="dui-ToolSettingDialogContent-ToolSet-Tool">
          <label>熱區 Hotspot</label>
          <Switch
            checked={toolSetting.hotspot}
            onChange={() => handleHotspotChange(!toolSetting.hotspot)}
          />
        </div>
      </div>
      {/* {shouldGoToSearchTreePanel() && (
        <Button onClick={handleGoSearchTreePanel}>目前沒有點位，請先搜尋紀錄</Button>
      )} */}
    </div>
  );
};
ToolSettingDialogContent.displayName = 'ToolSettingDialogContent';
export default ToolSettingDialogContent;
